import { render, staticRenderFns } from "./AboutUsWidget.vue?vue&type=template&id=614e5c7c&scoped=true&"
import script from "./AboutUsWidget.vue?vue&type=script&lang=js&"
export * from "./AboutUsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614e5c7c",
  null
  
)

export default component.exports